import { Common } from "../Components/Canvas";
import eraser1 from "../images/eraser1.png";
import eraser2 from "../images/eraser2.png";
import eraser3 from "../images/eraser3.png";
import pencil1 from "../images/pencil1.png";
import pencil2 from "../images/pencil2.png";
import pencil3 from "../images/pencil3.png";
import brush1 from "../images/brush1.png";
import brush2 from "../images/brush2.png";
import brush3 from "../images/brush3.png";
import spray1 from "../images/spray1.png";
import spray2 from "../images/spray2.png";
import spray3 from "../images/spray3.png";
import eraserSelect1 from "../images/eraserSelect1.png";
import eraserSelect2 from "../images/eraserSelect2.png";
import eraserSelect3 from "../images/eraserSelect3.png";
import pencilSelect1 from "../images/pencilSelect1.png";
import pencilSelect2 from "../images/pencilSelect2.png";
import pencilSelect3 from "../images/pencilSelect3.png";
import brushSelect1 from "../images/brushSelect1.png";
import brushSelect2 from "../images/brushSelect2.png";
import brushSelect3 from "../images/brushSelect3.png";
import spraySelect1 from "../images/spraySelect1.png";
import spraySelect2 from "../images/spraySelect2.png";
import spraySelect3 from "../images/spraySelect3.png";
import checkers from "../images/checkers.png";
import clouds from "../images/clouds.png";
import hills from "../images/hills.png";
import railtrack from "../images/railtrack.png";
import rainbow from "../images/rainbow.png";
import spots from "../images/spots.png";
import stars from "../images/stars.png";
import chevron from "../images/chevron.png";
import footprints from "../images/footprints.png";
import houses from "../images/houses.png";
import rainbow_stripes from "../images/rainbow_stripes.png";
import glitter_gold from "../images/glitter_gold.png";
import glitter_silver from "../images/glitter_silver.png";
import glitter_pink from "../images/glitter_pink.png";
import glitter_blue from "../images/glitter_blue.png";
import glitter_brown from "../images/glitter_brown.png";
import slime_green from "../images/slime_green.png";
import slime_blue from "../images/slime_blue.png";
import slime_peach from "../images/slime_peach.png";
import slime_purple from "../images/slime_purple.png";

let colors = [
  glitter_silver,
  glitter_gold,
  glitter_pink,
  glitter_blue,
  glitter_brown,
  slime_green,
  slime_blue,
  slime_peach,
  slime_purple,
  "#ce2002",
  "#e7481d",
  "#e30083",
  "#fe54b7",
  "#ffc4f1",
  "#fe8efd",
  "#ee1dee",
  "#c019c2",
  "#8f0290",
  "#22276e",
  "#3d4ac0",
  "#1287c4",
  "#47b7e5",
  "#06f4f5",
  "#cefe04",
  "#8efe04",
  "#8bcd11",
  "#1c9d44",
  "#8b4403",
  "#c15d00",
  "#ff7d05",
  "#feb106",
  "#ffd13f",
  "#fdff00",
  "#d0d0d0",
  "#909090",
  "#000000",
];

export let glitterShadowColor = [
  "#B7B7B7",
  "#DFD31D",
  "#D560DE",
  "#3BA0EF",
  "#CD4226",
  "#5EB02F",
  "#37A9D1",
  "#FF8060",
  "#B81EFF",
];

// UI tools to display for user to pick;
export function getColorsOptions(tool) {
  let options = {
    pencil: colors,
    brush: colors,
    spray: colors,
    bucket: colors,
  };

  return options[tool];
}

export function getSizesOptions(tool) {
  let options = {
    eraser: [eraser1, eraser2, eraser3],
    pencil: [pencil1, pencil2, pencil3],
    brush: [brush1, brush2, brush3],
    spray: [spray1, spray2, spray3],
  };

  return options[tool];
}

export function getSizesSelected(tool) {
  let options = {
    eraser: [eraserSelect1, eraserSelect2, eraserSelect3],
    pencil: [pencilSelect1, pencilSelect2, pencilSelect3],
    brush: [brushSelect1, brushSelect2, brushSelect3],
    spray: [spraySelect1, spraySelect2, spraySelect3],
  };

  return options[tool];
}

export const getTapes = () => {
  let options = [
    checkers,
    clouds,
    hills,
    railtrack,
    rainbow,
    spots,
    stars,
    chevron,
    rainbow_stripes,
    houses,
    footprints,
  ];

  return options;
};

// programmatically size tools ;
export function getSizeAndPath(tool) {
  let options = {
    eraser: [5, 20, 35],
    pencil: [2, 7, 12],
    brush: [17, 22, 27],
    spray: [32, 37, 42],
  };

  // set mobile size for some tools;
  if (Common.font_size) {
    options.spray = options.spray.map((size) => getSize(size, 0.4));
    options.eraser[1] = getSize(options.eraser[1], 0.4);
    options.eraser[2] = getSize(options.eraser[2], 0.4);
    options.brush[0] = getSize(options.brush[0], 0.5);
    options.brush[1] = getSize(options.brush[1], 0.6);
    options.brush[2] = getSize(options.brush[2], 0.56);
  }

  function getSize(initial_size, multiplier) {
    return Math.round(0.0194 * Common.font_size + multiplier * initial_size);
  }

  return options[tool];
}
